<kendo-appbar position="top" positionMode="sticky">
  <kendo-appbar-section>
    <div class="appbar-logo">
      <app-logo />
    </div>
  </kendo-appbar-section>

  <kendo-appbar-spacer></kendo-appbar-spacer>

  <kendo-appbar-section>
    <div class="appbar-center">
      @if (domains$ | async; as domains) {
        @if (currentDomainId$ | async; as currentDomainId) {
          <app-domain-selector
            [domains]="domains"
            [selectedDomainId]="currentDomainId"
            (domainChange)="onDomainChange($event)"
          />
        }
      }
    </div>
  </kendo-appbar-section>

  <kendo-appbar-spacer></kendo-appbar-spacer>

  <kendo-appbar-section>
    <div class="appbar-actions">
      @if (userData$ | async; as userData) {
        <app-user-menu
          [userFullName]="userData.fullName"
          [userEmail]="userData.email"
          [userPhoto]="userData.photo"
          [userInitials]="userData.initials"
          (accountClick)="onAccountClick()"
          (logoutClick)="onLogoutClick()"
        />
      }
    </div>
  </kendo-appbar-section>
</kendo-appbar>
